export const primaryColor = "#D0006F"
